export const ergoProjectsConstants = {
  GET_ERGO_PROJECTS_REQUEST: 'GET_ERGO_PROJECTS_REQUEST',
  GET_ERGO_PROJECTS_SUCCESS: 'GET_ERGO_PROJECTS_SUCCESS',
  GET_ERGO_PROJECTS_FAILURE: 'GET_ERGO_PROJECTS_FAILURE',
};
